import axios from 'axios';
import './utils/Date';
import {
  Collapse, Dropdown, Modal, Popover,
} from 'bootstrap';
import Vue from 'vue';
import FlashMessage from '@smartweb/vue-flash-message';
import VueCookies from 'vue-cookie';
import lodash from 'lodash';
import VueRouter from 'vue-router';
import GlobalEvents from './utils/GlobalEvents';
import IoStorage from './utils/IoStorage';
import IOH from './utils/IOH';
import GlobalMixin from './mixins/global-mixin';

Vue.prototype.IOH = IOH;
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.use(VueRouter);
Vue.use(lodash);
Vue.use(FlashMessage);
Vue.use(VueCookies);

Vue.mixin(GlobalMixin);

window.Vue = Vue;
window._ = lodash;
window.GlobalEvents = new GlobalEvents();
window.bsCollapse = Collapse;
window.bsDropdown = Dropdown;
window.bsModal = Modal;
window.bsPopover = Popover;
window.IoStorage = IoStorage;

if (typeof window.IOC === 'undefined') {
  window.IOC = {};
}
